<template>
  <div
    class="base-icon"
    v-html="iconSvg"
  ></div>
</template>
<script setup lang="ts">
import {ref, watchEffect} from "vue"

const props = defineProps({
  icon: {
    type: String,
    required: true,
  },
})

const iconSvg = ref("")

watchEffect(async () => {
  if (props.icon) {
    try {
      const module = await import(`../assets/icons/${props.icon}.svg?raw`)
      iconSvg.value = module.default
    } catch (error) {
      console.error(`Error loading icon: ${props.icon}`, error)
    }
  }
})
</script>
<style scoped lang="less">
.base-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  stroke: currentColor;
  fill: currentColor;
  font-size: inherit;

  //   ::v-deep(svg) {
  //     height: 100%;
  //     width: auto;
  //   }
}
</style>
